module.exports = __webpack_public_path__ + "static/media/1_A1_19.a3e3767b.png";